import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { PROFILE_PLACES } from '~/components/profiles';
import type { Profile, ProfilesState } from '~/types/profile';

const defaultProfile: Profile = {
  name: 'default',
  places: PROFILE_PLACES.Default,
};

const initialState: ProfilesState = {
  selected_profile: 'default',
  profiles: {
    default: { ...defaultProfile },
  },
};

const profilesSlice = createSlice({
  name: 'profiles',
  initialState,
  reducers: {
    createProfile(state, action: PayloadAction<{ name: string; defaultPlace: string }>) {
      const { name, defaultPlace } = action.payload;
      if (!state.profiles[name]) {
        state.profiles[name] = {
          ...defaultProfile,
          name,
          places: PROFILE_PLACES[defaultPlace],
        };
      }
    },
    updateProfile(state, action: PayloadAction<Profile>) {
      state.profiles[action.payload.name] = action.payload;
    },
    deleteProfile(state, action: PayloadAction<{ name: string }>) {
      delete state.profiles[action.payload.name];

      // switch to first available profile if deleted profile was selected
      if (state.selected_profile === action.payload.name) {
        state.selected_profile = Object.keys(state.profiles)[0];
      }
    },
    renameProfile(
      state,
      action: PayloadAction<{
        oldName: string;
        newName: string;
      }>,
    ) {
      const { oldName, newName } = action.payload;
      const profile = state.profiles[oldName];
      if (profile) {
        state.profiles[newName] = { ...profile, name: newName };
        delete state.profiles[oldName];
        if (state.selected_profile === oldName) {
          state.selected_profile = newName;
        }
      }
    },
    switchProfile(state, action: PayloadAction<{ name: string }>) {
      const { name } = action.payload;
      if (name in state.profiles) {
        state.selected_profile = name;
      }
    },
  },
});

export const { createProfile, updateProfile, deleteProfile, renameProfile, switchProfile } =
  profilesSlice.actions;
export default profilesSlice.reducer;
